import { create } from 'zustand'
import { PhoneData } from '@/types'

interface MessagingMethod {
  code: 'sms' | 'whatsapp' | 'telegram'
  imgUrl?: string
}

interface AddPhoneState {
  // Phone data
  phone: PhoneData | null

  // Messaging method
  messagingMethod: MessagingMethod

  // Actions
  setPhone: (phone: PhoneData | null) => void
  setMessagingMethod: (method: MessagingMethod) => void
  reset: () => void
}

const initialState = {
  phone: null,
  messagingMethod: {
    code: 'sms' as const,
    imgUrl: undefined,
  },
}

export const useAddPhoneStore = create<AddPhoneState>((set) => ({
  ...initialState,

  setPhone: (phone) => set({ phone }),

  setMessagingMethod: (messagingMethod) => set({ messagingMethod }),

  reset: () => set(initialState),
}))
